<img *ngIf="photo != ''" [src]="getImage(photo)" [matTooltip]="title" (click)="viewPhoto()"/>
